__turbopack_context__.v({
  "Stick": "gE3yWG_Stick",
  "activeLink": "gE3yWG_activeLink",
  "container": "gE3yWG_container",
  "containerDark": "gE3yWG_containerDark",
  "gilroyFontFamily": "gE3yWG_gilroyFontFamily",
  "icon": "gE3yWG_icon",
  "linkStyle": "gE3yWG_linkStyle",
  "notStick": "gE3yWG_notStick",
  "titleStyles": "gE3yWG_titleStyles",
  "titleStylesDark": "gE3yWG_titleStylesDark",
  "verticalLine": "gE3yWG_verticalLine",
  "verticalLineEn": "gE3yWG_verticalLineEn",
});
